import React, { FC, ReactNode } from 'react';

import { CloseIcon } from '../../../assets/icons/index';
import rocket from '../../../assets/images/rocket.jpeg';
import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import Button from '../../../components/button/index';
import { DeprecatedModalWrapper } from '../../../components/modal/index';
import { StakeholderRole } from '../../../types/stakeholder.types';

export type UpgradePlanModalProps = {
  isOpen: boolean;
  onDismiss: () => void;
  onSuccess: () => void;
  planName: ReactNode | string;
  // Optional: the modal renders while the selected company is still resolving, and only the
  // admin-only upgrade CTA depends on the role.
  stakeholderRole?: StakeholderRole;
};

const UpgradePlanModal: FC<UpgradePlanModalProps> = ({
  planName,
  onDismiss,
  onSuccess,
  isOpen,
  stakeholderRole,
}) => {
  return (
    <DeprecatedModalWrapper isOpen={isOpen}>
      <div className="relative flex w-full max-w-[360px] flex-col overflow-hidden rounded bg-white shadow-3xl">
        <div className="absolute left-0 top-4 flex w-full items-center justify-between px-4">
          <span className="w-fit rounded bg-[#34405480] px-2 py-1 text-xs text-white">
            <AppFormattedMessage id="CURRENT_PLAN" />: {planName}
          </span>
          <Button
            className="flex size-6 items-center justify-center rounded-full bg-[#34405480]"
            onClick={onDismiss}
            styleType="NONE"
          >
            <CloseIcon iconColor="#ffffff" />
          </Button>
        </div>
        <img alt="" className="h-[270px] w-full object-cover" src={rocket} />
        <div className="flex h-full w-full flex-col items-center gap-6 px-4 py-8 text-center">
          <span className="text-xl font-[550] text-gray-700">
            <AppFormattedMessage id="SKYROCKETING" />
          </span>
          <span className="text-xs font-[450] text-gray-700">
            <AppFormattedMessage id="CONGRATS_ON_YOUR_GROWTH" />
          </span>
          {stakeholderRole === StakeholderRole.ADMIN && (
            <Button className="w-fit px-4 py-[6px]" onClick={onSuccess}>
              <AppFormattedMessage id="UPGRADE_PLAN_NOW" />
            </Button>
          )}
        </div>
      </div>
    </DeprecatedModalWrapper>
  );
};

export default UpgradePlanModal;
